module.exports = __webpack_public_path__ + "static/media/empty-state-no-data.2421a428.svg";